import ICustomForm from "../../ICustomForm";
import Hub from "../Hub";

/**
 * Hub
 *
 * Transform form with single radio list to hub
 */
export default class HubDefault extends Hub implements ICustomForm {

}
